<div class="count">
  <div class="container">
    <div class="card card-3"></div>
    <div class="card card-2"></div>
    <div class="card">
      <div class="login-container">
        <h2>Criar Nova Senha</h2>
        <p class="subtitle">Escolha uma senha definitiva para aceder à sua conta.</p>

        <form (ngSubmit)="salvarNovaSenha()">
          <input type="password" name="novaSenha" [(ngModel)]="novaSenha" placeholder="Nova Senha" required />
          <input type="password" name="confirmarSenha" [(ngModel)]="confirmarSenha" placeholder="Confirmar Nova Senha" required />
          <button type="submit">Salvar e Entrar</button>
        </form>
      </div>
    </div>
  </div>
</div>